import { Dialog, DialogContent } from "@mui/material";
import { type FC, type ReactNode } from "react";

import { SignUpSuccess } from "~/feature/auth/components/SignUpSuccess/SignUpSuccess";
import { useSignUpSuccess } from "~/feature/auth/hooks/useSignUpSuccess";

interface ISignUpSuccessDialogProps {
  children: (handleSuccess: () => void) => ReactNode;
}

export const SignUpSuccessDialog: FC<ISignUpSuccessDialogProps> = ({
  children,
}) => {
  const { isSuccess, handleSuccess, handleClose } = useSignUpSuccess();

  return (
    <>
      <Dialog open={isSuccess} onClose={handleClose} maxWidth="xs">
        <DialogContent>
          <SignUpSuccess onClose={handleClose} />
        </DialogContent>
      </Dialog>
      {children(handleSuccess)}
    </>
  );
};
